export default __webpack_public_path__ + "static/media/cloud.38c6a7c8.svg";